import $ from 'jquery';

export class AlzUtils {
    static readonly DataLayerPurchaseKey = 'datalayerpurchase';

    getAddressBySsn(ssn: string): JQuery.jqXHR {
        return $.ajax('/api/donations/address', {
            method: 'POST',
            data: JSON.stringify({ ssn }),
            contentType: 'application/json; charset=utf-8'
        });
    }

    validSsn4digitYear(ssn: string): boolean {
        return /^(19|20)[0-9]{2}[- ]?((0[0-9])|(10|11|12))[- ]?(([0-2][0-9])|(3[0-1])|(([7-8][0-9])|(6[1-9])|(9[0-1])))[- ]?[0-9]{4}$/.test(ssn);
    }

    validSsn(ssn: string): boolean {
        return /^(19|20)?[0-9]{2}[- ]?((0[0-9])|(10|11|12))[- ]?(([0-2][0-9])|(3[0-1])|(([7-8][0-9])|(6[1-9])|(9[0-1])))[- ]?[0-9]{4}$/.test(ssn);
    }

    validEmail(email: string): boolean {
        return /(.+)@(.+){2,}\.(.+){2,}/.test(email);
    }

    isJquery(obj: unknown): obj is JQuery<HTMLElement> {
        return obj instanceof $;
    }

    isInViewport(element: HTMLElement | JQuery<HTMLElement>): boolean {
        const $element = this.isJquery(element) ? element : $(element);
        const elementTop = $element.offset()!.top;
        const elementBottom = elementTop + $element.outerHeight()!;
        const viewportTop = $(window).scrollTop()!;
        const viewportBottom = viewportTop + $(window).height()!;
        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    scrollTo(element: HTMLElement | JQuery<HTMLElement>): void {
        const $element = this.isJquery(element) ? element : $(element);
        if (!this.isInViewport($element)) {
            $('html, body').stop().animate({
                scrollTop: $element.offset()!.top - parseInt($element.css('scroll-margin-top'))
            }, 200, 'linear');
        }
    }

    getFileNameFromPath(fullPath: string): string {
        const startIndex = fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/');
        let filename = fullPath.substring(startIndex);
        if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
            filename = filename.substring(1);
        }
        return filename;
    }

    getFromLocalStorage(key: string): string | null {
        return window.localStorage.getItem(key);
    }

    setLocalStorage(key: string, val: string): void {
        window.localStorage.setItem(key, val);
    }

    deleteLocalStorage(key: string): void {
        window.localStorage.removeItem(key);
    }

    pushDataLayer(dataLayerObject: unknown): void {
        window._mtm = window._mtm || [];
        if (typeof window._mtm.push === 'function') {
            window._mtm.push(dataLayerObject as { push: (obj: unknown) => void });
        }
    }

    checkDataLayerPurchase = (): void => {
        const dataLayerPurchase = this.getFromLocalStorage(AlzUtils.DataLayerPurchaseKey);
        if (dataLayerPurchase) {
            this.pushDataLayer(JSON.parse(dataLayerPurchase));
            this.deleteLocalStorage(AlzUtils.DataLayerPurchaseKey);
        }
    };
}

export const utils = new AlzUtils();
